import { graphql } from 'gatsby';
import React from 'react';

import { ForgotPasswordQuery } from '../../../graphql-types';
import { TPageProps } from '../../page-props';
import ForgotPasswordPage from '../../templates/forgot-password';

export default (props: TPageProps<ForgotPasswordQuery>) => <ForgotPasswordPage {...props} />;

export const query = graphql`
  query ForgotPassword($lang: String) {
    prismicForgotPassword(lang: { eq: $lang }) {
      _previewable
      lang
      data {
        ...ForgotPasswordData
      }
    }
  }
`;
